/* eslint-disable prettier/prettier */
export const currentState =(state)=>{    
return state.status
}
export const dataSegip =(state)=>{    
    return state.segipResponse
}
export const listPpl =(state)=>{
     return state.listPrivatedLibertyPersons
}
export const countCentersByPersons =(state)=>{
    return state.countPersonsCenter
}
export const chartDataValues =(state)=>{
    return state.chartData
}
export const chartDataTwoParams =(state)=>{
    return state.chartDataTwoParams
}
export const chartStatus =(state)=>{
    return state.chartStatus
}
export const dataToEdit =(state)=>{
    return {"data":state.dataToEdit , "state": state.statusEdit}
}